import { create } from 'zustand';

// Remote Config values interface
export interface RemoteConfigValues {
  welcomeBonus: number;
  unlockCost: number;
  notificationReward: number;
  emailReward: number;
  shareYoutubeReward: number;
  shareFacebookReward: number;
  shareInstagramReward: number;
  friendShareReward: number;
  watch10Reward: number;
  watch20Reward: number;
  baseCheckinAmount: number;
}

// Default values (fallback)
const DEFAULT_CONFIG: RemoteConfigValues = {
  welcomeBonus: 5,
  unlockCost: 2,
  notificationReward: 5,
  emailReward: 5,
  shareYoutubeReward: 5,
  shareFacebookReward: 5,
  shareInstagramReward: 5,
  friendShareReward: 5,
  watch10Reward: 5,
  watch20Reward: 10,
  baseCheckinAmount: 5,
};

interface RemoteConfigStore {
  config: RemoteConfigValues;
  isInitialized: boolean;
  setConfig: (config: Partial<RemoteConfigValues>) => void;
  setInitialized: (initialized: boolean) => void;
  reset: () => void;
}

export const useRemoteConfigStore = create<RemoteConfigStore>((set) => ({
  config: DEFAULT_CONFIG,
  isInitialized: false,
  setConfig: (newConfig) =>
    set((state) => ({
      config: { ...state.config, ...newConfig },
    })),
  setInitialized: (initialized) => set({ isInitialized: initialized }),
  reset: () => set({ config: DEFAULT_CONFIG, isInitialized: false }),
}));
